var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-lg-9" },
    [
      _c(
        "h1",
        [
          _vm.isCatalogOrder
            ? [_vm._v("Votre commande catalogue")]
            : [_vm._v("Panier")]
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("flashes"),
      _vm._v(" "),
      !_vm.cartIsLoaded
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                "margin-top": "100px",
                color: "rgb(153, 153, 153)"
              }
            },
            [
              _c("i", { staticClass: "fa fa-circle-o-notch fa-spin fa-2x" }),
              _c("br"),
              _vm._v(" "),
              _c("i", [_vm._v("Chargement...")])
            ]
          )
        : _c(
            "div",
            [
              _vm.isCatalogOrder
                ? _c("div", { staticClass: "advantageCode" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { href: "#", role: "button" },
                          on: { click: _vm.doScroll }
                        },
                        [_vm._v("Ajouter mon code")]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "resume breakpointNav" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-lg-8 text-center text-lg-left" },
                        [
                          _vm._v(
                            "Il y a " +
                              _vm._s(_vm.countItems) +
                              " articles dans votre panier"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-lg-4 text-center text-lg-right" },
                        [
                          _vm._v("Total de vos articles : "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm._f("moneyFormat")(_vm.itemsTotal))
                            )
                          ])
                        ]
                      )
                    ])
                  ]),
              _vm._v(" "),
              _vm.items
                ? _c(
                    "div",
                    [
                      _vm._l(_vm.items, function(item) {
                        return null !== item.orderable &&
                          "site.repository.product_reference" ===
                            item.orderable.orderableRepository
                          ? _c("ponroy-cart-item", {
                              key: item.id,
                              attrs: {
                                type: item.orderable.orderableRepository,
                                reference: item.id,
                                title: item.orderable.data.title,
                                referenceTitle: item.referenceName,
                                referenceCode: item.orderableId,
                                referenceProduct: item.orderable.data.id,
                                unitPrice: item.unitPrice,
                                discountedUnitPrice: item.discountedUnitPrice,
                                total: item.total,
                                baseQuantity: item.quantity,
                                slug: item.orderable.data.slug,
                                mainImage: item.orderable.data.cardImage,
                                advantageName: item.advantageName
                              }
                            })
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.items, function(item) {
                        return null !== item.orderable &&
                          "site.repository.fidelity_gift" ===
                            item.orderable.orderableRepository
                          ? _c("ponroy-cart-item", {
                              key: item.id,
                              attrs: {
                                type: item.orderable.orderableRepository,
                                reference: item.id,
                                title: item.orderable.title,
                                referenceCode: item.orderable.id,
                                mainImage: item.orderable.image,
                                unitFidelityPoint: item.unitFidelityPoint,
                                total: item.totalFidelityPoint,
                                baseQuantity: item.quantity
                              }
                            })
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.items, function(item) {
                        return null !== item.orderable &&
                          "site.repository.gift" ===
                            item.orderable.orderableRepository &&
                          item.orderable.type !== "sample" &&
                          item.orderable.type !== "doc"
                          ? _c("ponroy-cart-item", {
                              key: item.id,
                              attrs: {
                                type: item.orderable.orderableRepository,
                                reference: item.id,
                                title: item.orderable.title,
                                referenceCode: item.orderable.id,
                                mainImage: item.orderable.image
                              }
                            })
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.items.length > 0 &&
                      undefined === _vm.gift &&
                      null !== _vm.giftsChoice &&
                      _vm.giftsChoice.length > 0 &&
                      _vm.giftsChoice.length <= 5
                        ? _c("div", { staticClass: "blocChooseGift" }, [
                            _vm.showErrorGiftChoice
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-danger text-center",
                                    attrs: { id: "error-gift-choice" }
                                  },
                                  [
                                    _vm._v(
                                      "\n          Merci de sélectionner un cadeau pour valider votre panier\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-lg-flex justify-content-around verticalChoice"
                              },
                              [
                                _c("h2", [_vm._v("Je choisis un cadeau")]),
                                _vm._v(" "),
                                _vm._l(_vm.giftsChoice, function(g) {
                                  return _c(
                                    "div",
                                    {
                                      key: g.id,
                                      staticClass: "custom-control custom-radio"
                                    },
                                    [
                                      _c("input", {
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "radio_" + g.id,
                                          name: "radio",
                                          type: "radio"
                                        },
                                        domProps: { value: g.id },
                                        on: {
                                          change: function(e) {
                                            return _vm.chooseGift(g)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "radio_" + g.id }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "thumbGift" },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "lazyload img-fluid",
                                                attrs: {
                                                  "data-src": g.image,
                                                  alt: g.title
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(g.title) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.items.length > 0 &&
                      undefined === _vm.gift &&
                      null !== _vm.giftsChoice &&
                      _vm.giftsChoice.length > 5
                        ? _c("div", { staticClass: "blocChooseGift" }, [
                            _vm.showErrorGiftChoice
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-danger text-center",
                                    attrs: { id: "error-gift-choice" }
                                  },
                                  [
                                    _vm._v(
                                      "\n          Merci de sélectionner un cadeau pour valider votre panier\n        "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-lg-flex justify-content-around verticalChoice"
                              },
                              [
                                _c("h2", { staticClass: "align-self-center" }, [
                                  _vm._v("Je choisis un cadeau")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "align-self-center",
                                    staticStyle: { "text-align": "center" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.giftsChoice,
                                        label: "fullTitle"
                                      },
                                      model: {
                                        value: _vm.selectedGift,
                                        callback: function($$v) {
                                          _vm.selectedGift = $$v
                                        },
                                        expression: "selectedGift"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function(e) {
                                            return _vm.validateSelectedGift()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Valider mon cadeau\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.teaser &&
                      _vm.shippingFees &&
                      _vm.shippingFees.amount > 0 &&
                      _vm.items.length > 0
                        ? _c("div", { staticClass: "teaser" }, [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(_vm.teaser) }
                            })
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filtredRecommendedProducts.length
                ? _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._l(_vm.recommendedProduct, function(item) {
                        return !_vm.inCart(item.id)
                          ? _c("ponroy-cart-recommendation", {
                              key: item.id,
                              attrs: {
                                repository: "site.repository.product_reference",
                                item: item,
                                reference: item.id
                              }
                            })
                          : _vm._e()
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ponroy-cart-search", {
                attrs: {
                  repository: _vm.repository,
                  "is-catalog-order": _vm.isCatalogOrder
                }
              }),
              _vm._v(" "),
              _vm.promotion && _vm.promotion.hasSample
                ? _c("ponroy-cart-samples")
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-5" }, [
                  !_vm.promotion || _vm.promotion.automatic
                    ? _c(
                        "div",
                        {
                          staticClass: "blocCodePromo text-center",
                          attrs: { id: "blocCodePromo" }
                        },
                        [
                          _c("h4", [_vm._v("Code avantage")]),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              staticClass: "form-inline",
                              attrs: {
                                action: _vm.enterPromoUrl,
                                method: "POST"
                              }
                            },
                            [
                              _c("input", {
                                attrs: { type: "hidden", name: "no_redirect" }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "sr-only",
                                    attrs: { for: "coupon_code" }
                                  },
                                  [_vm._v("Code avantage")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.couponText,
                                      expression: "couponText"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    name: "coupon_code",
                                    id: "coupon_code_input",
                                    placeholder: "Code avantage"
                                  },
                                  domProps: { value: _vm.couponText },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.couponText = $event.target.value
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _vm.hasHomeInput && !_vm.awaitingHasHomeInput
                                ? _c("div", { staticClass: "form-group" }, [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "sr-only",
                                        attrs: { for: "code_home" }
                                      },
                                      [_vm._v("Code client")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        name: "code_home",
                                        placeholder: "Code client"
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.awaitingHasHomeInput
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn",
                                      staticStyle: { margin: "auto" },
                                      attrs: { disabled: "", type: "submit" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-spinner fa-spin"
                                      })
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass: "btn",
                                      staticStyle: { margin: "auto" },
                                      attrs: {
                                        type: "submit",
                                        "data-trk-promo-code": _vm.couponText
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Appliquer\n            "
                                      )
                                    ]
                                  )
                            ]
                          )
                        ]
                      )
                    : _c("div", { staticClass: "blocCodePromo text-center" }, [
                        _c("h4", [
                          _c("small", [_vm._v("Votre promotion")]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(_vm._s(_vm.promotionCode))
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.promotion.cartText)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "form-inline",
                            attrs: { action: _vm.enterPromoUrl, method: "POST" }
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "coupon_code" }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btnDelete",
                                attrs: { type: "submit" }
                              },
                              [_vm._v("Annuler ce code avantage")]
                            )
                          ]
                        )
                      ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-7" }, [
                  _c("div", { staticClass: "blocTotal" }, [
                    _c("div", { staticClass: "lineTotalArticles" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-8" }, [
                          _vm._v("Total de vos articles")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4" }, [
                          _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.itemsTotal)))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.totalFidelityPoint > 0
                      ? _c("div", { staticClass: "lineTotalFidelityGift" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-8" }, [
                              _vm._v("Total de vos cadeaux")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _vm._v(_vm._s(_vm.totalFidelityPoint) + " points")
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.discountAmount != 0
                      ? _c("div", { staticClass: "lineCodePromo" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-8" }, [
                              _vm._v("Code avantage "),
                              _c("code", [_vm._v(_vm._s(_vm.promotionCode))])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moneyFormat")(_vm.discountAmount)
                                )
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "lineLivraison" }, [
                      _vm.shippingFees
                        ? _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-8" }, [
                              _vm._v("Frais de livraison\n                "),
                              _vm.teaser &&
                              _vm.shippingFees.amount > 0 &&
                              _vm.items.length > 0
                                ? _c("small", {
                                    domProps: { innerHTML: _vm._s(_vm.teaser) }
                                  })
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moneyFormat")(_vm.shippingFees.amount)
                                )
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "lineTotal" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-6 col-lg-8 text-left text-lg-right"
                          },
                          [_vm._v("  TOTAL")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 col-lg-4" }, [
                          _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.total)))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.gain > 0 && _vm.showFidelityPoints
                      ? _c("div", { staticClass: "lineFidelite" }, [
                          _vm._v("\n            Votre commande vous rapporte "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.gain) +
                                " point" +
                                _vm._s(_vm.gain > 1 ? "s" : "") +
                                " fidélité "
                            ),
                            _c("i", { staticClass: "fa fa-heart" })
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btnSubmitCart float-lg-right",
                      class: {
                        "btn-primary": _vm.isValid(),
                        disabled: !_vm.isValid()
                      },
                      attrs: { type: "submit" },
                      on: {
                        click: function(e) {
                          return _vm.validate(e)
                        }
                      }
                    },
                    [_vm._v("Valider mon panier\n        ")]
                  )
                ])
              ])
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "text-center align-baseline" }, [
        _vm._v("Vous avez un code avantage ?")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "rgba(119, 135, 129, 0.2)",
            color: "#778781",
            padding: "0 10px",
            display: "inline-block",
            "font-size": "1rem",
            "font-weight": "bolder",
            "border-radius": "0.25rem 0.25rem 0 0"
          }
        },
        [_vm._v("Nous vous recommandons\n        ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Si vous disposez d'un code avantage,"),
      _c("br"),
      _vm._v(" veuillez le noter ci-dessous")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e089414", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e089414","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Cart.vue
// module id = 506
// module chunks = 1